/*
 * @Author: liuziwei
 * @Date: 2023-08-07 14:37:35
 * @LastEditTime: 2023-08-29 11:34:52
 * @LastEditors: liuziwei
 * @Description: 卡片容器
 * 睡觉了, 帮我关一下月亮 🌙  ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ
 */
<template minapp='mpx' xlang='wxml'>
  <!-- 领域展开 -->
  <view class="card-frame-container">
    <!-- title-area -->
    <view class="card-frame-title" style="{{cardTitleStyle}}">
      <!-- 左边 -->
      <view class="title-area" style="{{titleStyle}}">
        <image wx:if="{{titleInfo.newCustomerIcon}}" class="title-customer-icon" src="{{titleInfo.newCustomerIcon}}" />
        <image wx:if="{{titleInfo.icon}}" src="{{titleInfo.icon}}" class="title-icon" />
        <text class="customer-text" wx:if="{{titleInfo.newCustomerText}}">{{titleInfo.newCustomerText}}</text>
        <special-text wx:if="{{titleInfo.text}}" class="title-text" rules="{{specialRules}}" text="{{titleInfo.text}}" />
      </view>
      <!-- 右边 -->
      <view
        class="extra-area"
        wx:if="{{extraInfo.text}}"
        style="{{extraStyle}}"
        bindtap="clickExtra"
      >
        <text class="extra-text">{{ extraInfo.text }}</text>
      </view>
    </view>
    <!-- 内容部分 -->
    <view class="card-frame-content">
      <slot></slot>
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    props: {
      cardConf: {
        type: Object,
        value: () => {}
      }
    },
    computed: {
      // 富文本样式
      specialRules() {
        return {
          '{{x}}': {
            // 放大 & 高亮
            style: `font-size: ${this.titleInfo?.fontSize || '16px'}; color: ${
              this.titleInfo?.fontColor ?? '#FF6400'
            }`
          }
        }
      },
      // title 部分信息
      titleInfo() {
        return this.cardConf?.title || {}
      },
      // title 文案样式
      titleStyle() {
        return `color: ${this.titleInfo?.color || '#333'}`
      },
      cardTitleStyle() {
        return `marginBottom: ${this.titleInfo.newCustomerIcon ? '-8px' : 0}`
      },
      // extra 部分信息
      extraInfo() {
        return this.cardConf?.extra || {}
      },
      // extra 文案样式
      extraStyle() {
        return `color: ${this.extraInfo?.color || '#333'}`
      }
    },
    methods: {
      // 点击 extra 区域
      clickExtra() {
        // 上报事件
        this.triggerEvent('clickExtra')
      }
    }
  })
</script>

<style lang='stylus' scoped>
  .card-frame-container
    padding 12px
    .card-frame-title
      display flex
      align-items center
      justify-content space-between
      .title-area
        display flex
        align-items center
        .title-customer-icon
          background-size 100% 100%
          width 86px
          height 28px
          margin-right 4px
        .customer-text
          color #968378
          font-size 10px
        .title-text
          font-size 16px
          font-family PingFang SC
          line-height 16px
          font-weight 600
        .title-icon
          width 16px
          height 16px
          flex-shrink 0
          margin-right 4px
      .extra-area
        position relative
        line-height 12px
        .extra-text
          font-family PingFang SC
          font-size 12px
          font-weight normal
          padding-right 6px
          &::after
            content ''
            width 4px
            height 4px
            border-top 1px solid
            border-right 1px solid
            position absolute
            top 5px
            right 0
            transform rotate(45deg)
</style>

<script name='json'>
  module.exports = {
    usingComponents: {
      'special-text': '@didi/mpx-ui/src/components/special-text/index'
    }
  }
</script>
